//
import { combineActions, handleActions } from 'redux-actions';

import { resourceUndoUpserters, resourceUpserters } from 'app-components/flux/core';

import * as actions from './actions';
import { mkTripsStore } from './types';

const tripsReducer = handleActions(
  {
    [actions.createTrip]: (state) => state.set('isLoading', true),
    [actions.createTripSuccess]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.deleteTrip),

    [actions.updateTrip]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateTrip),
    [actions.updateTripSuccess]: (state, { payload: trip }) => resourceUpserters.upsertResource(state, trip),

    [actions.deleteTrip]: (state, action) =>
      resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.createTrip),
    [actions.deleteTripSuccess]: (state, { payload: trip }) => resourceUpserters.upsertResource(state, trip),

    [actions.getTrips]: (state) => state.set('isLoading', true),
    [actions.getTripsSuccess]: (state, { payload: data }) => resourceUpserters.upsertResources(state, data),
    [actions.getTripsFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),

    [combineActions(actions.createTripFailure, actions.updateTripFailure, actions.deleteTripFailure)]: (
      state,
      { payload: error, asyncDispatch },
    ) => {
      asyncDispatch(actions.getTrips());
      return resourceUpserters.resetResources(state, error);
    },
  },
  mkTripsStore(),
);

export const REDUCER_KEY = 'tripsStore';
export default tripsReducer;
